import { useForm } from "react-hook-form";
import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
// import toast, {Toaster} from "react-hot-toast";
import { toast, ToastContainer } from "react-toastify";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";

import { PatentContext } from "../../../../context/PatentContextProvider";

export default function AdminLogin() {
  const { handleLinkClick } = useContext(PatentContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (location.state?.isLoggedOut) {
      // Display the toast
      toast.success("Successfully logged out");
      // Clear the state to prevent the toast from reappearing
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    handleLinkClick("/allpages");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_PATH}/login`,
        data
      );

      if (response.status === 200) {
        localStorage.setItem("token", response.data.token);
        toast.success("User logged in successfully");
        navigate("/allpages", { state: { isLoggedIn: true } });
        // if (response.data.user.role === "user") {
        //   setTimeout(() => {
        //     navigate("/companies", { state: { isLoggedIn: true } });
        //   }, 500);
        // } else {
        //   setTimeout(() => {
        //     navigate("/allpages", { state: { isLoggedIn: true } });
        //   }, 500);
        // }
      }
      reset();
    } catch (error) {
      toast.error(
        "Invalid Login Credential:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <div>
      <section className="bg-gradient-to-b from-gray-300 to-gray-400">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                Sign in to your account
              </h1>
              <form
                className="space-y-4 md:space-y-6"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="name@example.com"
                    {...register("email", {
                      required: "Email is required",
                      validate: {
                        maxLength: (v) =>
                          v.length <= 50 ||
                          "The email should have at most 50 characters",
                        matchPattern: (v) =>
                          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                            v
                          ) || "Email address must be a valid address",
                      },
                    })}
                  />
                  {errors.email && (
                    <small className="text-red-500 mt-1 block text-xs">
                      {errors.email.message}
                    </small>
                  )}
                </div>
                <div className="relative">
                  <label
                    for="password"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Password
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="••••••••"
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    {...register("password", {
                      required: "Password is required",
                      validate: {
                        matchPattern: (v) =>
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
                            v
                          ) ||
                          "Password must have at least 8 characters, including an uppercase letter, a lowercase letter, a number, and a special character.",
                      },
                    })}
                  />
                  <div
                    className="absolute top-10 right-3 cursor-pointer text-gray-500"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FiEye size={20} />
                    ) : (
                      <FiEyeOff size={20} />
                    )}
                  </div>
                  {errors.password && (
                    <small className="text-red-500 text-xs">
                      {errors.password.message}
                    </small>
                  )}
                </div>
                <div>
               {/* <p className="text-white"> No account? <Link className="text-primary-600" to = "/register">Sign up now</Link></p> */}
                </div>
                <button
                  type="submit"
                  className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                >
                  Sign in
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer position="top-right" autoClose={2000} />
    </div>
  );
}
